import React, { useEffect, useState, useRef } from 'react';

function OurLibrary({ stories = [], addStory, allowUpload = true }) {
  const images = stories.filter(s => s.imagePath).map(s => ({ id: s._id || s.id, url: s.imagePath, title: s.title }));
  const [index, setIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isPlaying && images.length > 0) {
      intervalRef.current = setInterval(() => {
        setIndex(i => (i + 1) % images.length);
      }, 3000);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPlaying, images.length]);

  useEffect(() => {
    if (index >= images.length) setIndex(0);
  }, [images.length, index]);

  const prev = () => setIndex(i => (i - 1 + images.length) % images.length);
  const next = () => setIndex(i => (i + 1) % images.length);

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    setFile(f);
    if (f) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(f);
    } else setPreview(null);
  };

  const handleUpload = async () => {
    if (!file || isUploading) return;
    if (!allowUpload) return; // guard
    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('title', 'Our Memory');
      formData.append('content', '');
      const res = await fetch('https://storypublisher.onrender.com/gallery', {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('Upload failed');
      const saved = await res.json();
      if (addStory) addStory(saved);
      setFile(null);
      setPreview(null);
      setIsPlaying(true);
    } catch (err) {
      console.error('Upload error', err);
      alert('Upload failed');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="our-library">
      <h2>Our Gallery</h2>
      <div className="slideshow">
        {images.length === 0 ? (
          <div className="empty">No images yet.</div>
        ) : (
          <>
            <div className="slide">
              <img src={images[index].url} alt={images[index].title || 'gallery'} />
              {images[index].title && <div className="caption">{images[index].title}</div>}
            </div>
            <div className="controls">
              <button onClick={prev}>◀</button>
              <button onClick={() => setIsPlaying(p => !p)}>{isPlaying ? 'Pause' : 'Play'}</button>
              <button onClick={next}>▶</button>
            </div>
            <div className="thumbs">
              {images.map((img, i) => (
                <button key={img.id} className={i === index ? 'active' : ''} onClick={() => setIndex(i)}>
                  <img src={img.url} alt="thumb" />
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      {allowUpload && (
        <div className="uploader">
          <h3>Add a picture</h3>
          <input type="file" accept="image/*" onChange={handleFileChange} />
          {preview && <div className="preview"><img src={preview} alt="preview" /></div>}
          <button onClick={handleUpload} disabled={!file || isUploading}>{isUploading ? 'Uploading...' : 'Upload'}</button>
        </div>
      )}
    </div>
  );
}

export default OurLibrary;
